// Local SEO landing pages config — each entry renders via pages/LocalPage.jsx.
// tKey points to the translations block, cityRegex filters portfolio works by location.
// PVC pages render the full PvcProfiles carousel + NzebSection instead of a models strip.
const GARAJ_MODELS = [
  { sketch: 'single', name: 'SINGLE' },
  { sketch: 'multi', name: 'MULTI' },
  { sketch: 'flat', name: 'FLAT' },
  { sketch: 'blocks', name: 'BLOCKS' },
  { sketch: 'multirib', name: 'MULTI RIB' },
];

export const LOCAL_PAGES = {
  garajTimisoara: {
    path: '/porti-de-garaj-timisoara',
    tKey: 'localTm',
    service: 'garaj',
    heroKey: 'hero.garaj',
    heroFallback: '/images/hero-garaj.jpg',
    cityRegex: /timi/i,
    models: GARAJ_MODELS,
    modelsLinkTo: '/porti-de-garaj',
  },
  pvcTimisoara: {
    path: '/tamplarie-pvc-timisoara',
    tKey: 'localPvcTm',
    service: 'pvc',
    heroKey: 'hero.pvc',
    heroFallback: '/images/chapter-pvc.jpg',
    cityRegex: /timi/i,
  },
  garajArad: {
    path: '/porti-de-garaj-arad',
    tKey: 'localGarajArad',
    service: 'garaj',
    heroKey: 'hero.garaj',
    heroFallback: '/images/hero-garaj.jpg',
    cityRegex: /arad/i,
    models: GARAJ_MODELS,
    modelsLinkTo: '/porti-de-garaj',
  },
  pvcArad: {
    path: '/tamplarie-pvc-arad',
    tKey: 'localPvcArad',
    service: 'pvc',
    heroKey: 'hero.pvc',
    heroFallback: '/images/chapter-pvc.jpg',
    cityRegex: /arad/i,
  },
  rulouriTimisoara: {
    path: '/rulouri-timisoara',
    tKey: 'localRulouriTm',
    service: 'rulouri',
    heroKey: 'hero.rulouri',
    heroFallback: '/images/chapter-pvc.jpg',
    cityRegex: /timi/i,
    modelsLinkTo: '/rulouri',
  },
  rulouriArad: {
    path: '/rulouri-arad',
    tKey: 'localRulouriArad',
    service: 'rulouri',
    heroKey: 'hero.rulouri',
    heroFallback: '/images/chapter-pvc.jpg',
    cityRegex: /arad/i,
    modelsLinkTo: '/rulouri',
  },
};
